<template>
  <div class="sy-drop-down">
    <div v-if="!isPureText">
      <cascade-select :data="list" :disabled="disabled" v-bind="treeProps" v-if="style !== 1" v-on="$listeners"
                    :selectedIds.sync="selectedKeys" :selectedKeys.sync="selectedKeys" :props="selectprops"
                    :size="'medium'" :showType="showType" @change="treeChange" clearable></cascade-select>
      <select-tree :selectedKeys.sync="selectedKeys" v-else :disabled="disabled" ref="selectTree" v-on="$listeners"
                  v-bind="treeProps" :data="list" :showComplete="showComplete" :props="selectprops"
                  @change="treeChange"/>
      <el-input v-model="value" v-show="false"></el-input>
    </div>
    <read-text v-else :value="pureText"></read-text>
  </div>
</template>

<style lang="scss">
  .sy-drop-down {
    .el-select {
      width: 100%;
    }
  }
</style>

<script>
  import selectTree from '../../../../../basis/tree-selector/index.vue'
  import cascadeSelect from '../../../../../basis/cascade-selector/index.vue'
  import {dropDownTreeProps, initValue} from './index.js'

  export default {
    name: 'drop-down-tree',
    model: {
      event: 'tree-change',
      prop: 'value'
    },
    computed: {
      treeProps () {
        return {
          placeholder: this.placeholder,
          checkStrictly: true,
          mustLeaf: false,
          selectedData: this.selectedData,
          ...this.$attrs,
          ...this.$props
        }
      },
      pureText () {
        return this.isPureText ? initValue(this.value) : this.value
      }
    },
    props: dropDownTreeProps,
    data () {
      return {}
    },
    components: {
      selectTree,
      cascadeSelect
    },
    watch: {
      selectedData: {
        handler () {
          this.initSelectKeys()
        },
        immediate: true
      }
    },
    methods: {
      // 初始化选项key
      initSelectKeys () {
        let selectedData = this.selectedData
        if (selectedData && selectedData.length) {
          selectedData.forEach((item) => {
            this.selectedKeys.push(item[this.selectprops.key])
          })
        }
      },
      treeChange ({simple: arr}) {
        const value = arr.map((v) => {
          return {
            ...v,
            _update: true
          }
        })
        this.$emit('tree-change', value)
      }
    }
  }
</script>
